module.exports = __webpack_public_path__ + "static/media/HappyFace.d6b40b4c.svg";